// extracted by mini-css-extract-plugin
module.exports = {"background-image":"what-we-do_background-image__mZMrh"};